interface MetaData {
  [key: string]: string | number | boolean | string[];
}

const PENDO_ANONYMOUS_ACCOUNT_ID = 'ANONYMOUS_ACCOUNT';

type CompanyInfo = {
  accountId: string;
  organizationName?: string;
};

type VisitorInfo = {
  id: string;
  role?: string;
  language?: string;
};

class PendoClient {
  static awaitPendoGuideIsCompleted() {
    const { pendo } = window as any;
    return new Promise <void>((resolve) => {
      const handler = setInterval(() => {
        if (!(pendo as any).getActiveGuide()) {
          resolve();
          clearInterval(handler);
        }
      }, 500);
    });
  }

  static init(): void {
    if (Object.hasOwn(window, 'pendo')) {
      const { pendo } = window as any;
      pendo.initialize({
        visitor: {},
        account: {
          id: PENDO_ANONYMOUS_ACCOUNT_ID,
        },
      });
    }
  }

  static identify(
    { companyInfo, visitorInfo }:
    { companyInfo: CompanyInfo, visitorInfo: VisitorInfo },
  ): void {
    if (Object.hasOwn(window, 'pendo')) {
      const { pendo } = window as any;
      pendo.identify({
        visitor: {
          id: visitorInfo.id,
          ...(visitorInfo.role ? { role: visitorInfo.role } : {}),
          ...(visitorInfo.language ? { language: visitorInfo.language } : {}),
        },
        account: {
          id: companyInfo.accountId,
          ...(companyInfo.organizationName ? { organization: companyInfo.organizationName } : {}),
        },
      });
    }
  }

  static track(trackType: string, metadata?: MetaData): void {
    const { pendo } = window as any;
    if (pendo.isReady()) {
      pendo.track(trackType, metadata);
    }
  }
}

export default PendoClient;
